import uploadApi from '../API/UploadApi';

export function uploadFileSuccess(file) {
  return {type: 'UPLOAD_FILE_SUCCESS', file};
}

export function uploadFile(file) {
    return function (dispatch) {
      return uploadApi.uploadFile(file).then(fileUploaded => {
        dispatch(uploadFileSuccess(fileUploaded));
        return fileUploaded;
    }).catch(error => {
      throw(error);
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/uploadActions.js